<template>
  <div class="taskSelectBox inlineFlex">
    <p>
      <v-select
      label="大分類"
      item-text="taskTypeName"
      item-value="taskTypeId"
      v-model="majorTaskType"
      :items="majorTaskList"
      :disabled="disabled || isInit"
      class="UXselect"
      color="#6D8DFF"
      hide-details
      outline
      solo
    ></v-select>
    </p>
    <p>
      <v-select
      label="中分類"
      item-text="taskTypeName"
      item-value="taskTypeId"
      v-model="middleTaskType"
      :items="middleTaskList"
      :disabled="disabled || isInit"
      class="UXselect"
      color="#6D8DFF"
      hide-details
      outline
      solo
      no-data-text="データがありません。"
    ></v-select>
    </p>
    <p>
      <v-select
      label="小分類"
      item-text="taskTypeName"
      item-value="taskTypeId"
      v-model="minorTaskType"
      :items="minorTaskList"
      :disabled="disabled || isInit"
      class="UXselect"
      color="#6D8DFF"
      hide-details
      outline
      solo
      no-data-text="データがありません。"
    ></v-select>
    </p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ticket_counsel_type',
  props: {
    updateMajorTaskType: Function,
    updateMiddleTaskType: Function,
    updateMinorTaskType: Function,
    disabled: Boolean
  },
  data: () => ({
    majorTaskType: null,
    middleTaskType: null,
    minorTaskType: null,
    majorTaskList: [],
    middleTaskList: [],
    minorTaskList: [],
    isInit: true,
    isChangeMode: true
  }),
  watch: {
    majorTaskType (data) {
      this.middleTaskList = []
      this.minorTaskList = []
      this.callMiddleTaskType(data)
    },
    middleTaskType (data) {
      this.minorTaskList = []
      this.callMinorTaskType(data)
    }
  },
  methods: {
    callMajorTaskType () {
      return new Promise((resolve, reject) => {
        this.axios.get('/gateway/ticket/brand/taskType/major', {
          params: {
            ticketBrandId: this.currentTicketBrandId
          }
        }).then((res) => {
          this.majorTaskList = res.data.data
        }).then(() => resolve())
      })
    },
    callMiddleTaskType () {
      return new Promise((resolve, reject) => {
        if (this.majorTaskType) {
          this.axios.get('/gateway/ticket/brand/taskType/middle', {
            params: {
              ticketBrandId: this.currentTicketBrandId,
              parentTaskTypeId: this.majorTaskType.taskTypeId ? this.majorTaskType.taskTypeId : this.majorTaskType
            }
          }).then((res) => {
            this.middleTaskList = res.data.data
            // this.middleTaskType = null
            // this.minorTaskType = null
          }).then(() => resolve())
        } else {
        }
      })
    },
    callMinorTaskType () {
      if (this.middleTaskType) {
        return new Promise((resolve, reject) => {
          this.axios.get('/gateway/ticket/brand/taskType/minor', {
            params: {
              ticketBrandId: this.currentTicketBrandId,
              parentTaskTypeId: this.middleTaskType.taskTypeId ? this.middleTaskType.taskTypeId : this.middleTaskType
            }
          }).then((res) => {
            this.minorTaskList = res.data.data
            // this.minorTaskType = null
          }).then(() => resolve())
        })
      } else {
      }
    },
    async initTaskType (data) {
      if (data.majorTaskType) {
        this.majorTaskList.push(data.majorTaskType)
        this.majorTaskType = data.majorTaskType
      }
      if (data.middleTaskType) {
        this.middleTaskList.push(data.middleTaskType)
        this.middleTaskType = data.middleTaskType
      }
      if (data.minorTaskType) {
        this.minorTaskList.push(data.minorTaskType)
        this.minorTaskType = data.minorTaskType
      }
    },
    resetAll () {
      this.majorTaskList = []
      this.middleTaskList = []
      this.minorTaskList = []
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
      this.isInit = false
    },
    getAllTaskType () {
      return {
        majorTaskType: this.majorTaskType,
        middleTaskType: this.middleTaskType,
        minorTaskType: this.minorTaskType
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'ticketAgentId'
    ])
  }
}
</script>

<style scoped lang="scss">
.taskSelectBox {
  width: 100%;
  p {
    margin: 0;
    padding-right:10px;
    width: 33.33%;
    &:last-child {
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_detail_counsel_type.vue